import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid, Chip } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import * as H from "helper";
import {
  getRewardCoinData,
} from "actions";

const useStyles = makeStyles((theme) =>
  createStyles({
    volt: {
      paddingTop: theme.spacing(0.5),
      backgroundColor: "#fd5842",
      color: "#fff",
    },
    ampere: {
      paddingTop: theme.spacing(0.3),
      backgroundColor: "#4ba0c1",
      color: "#fff",
    },
    watt: {
      paddingTop: theme.spacing(0.5),
      backgroundColor: "#6eb26e",
      color: "#fff",
    },
    box: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(1),
      borderRight: "1px solid #dcdcdc",
    },
    tableHead: {
      height: 48,
      backgroundColor: "#fafafa",
    },
    tableRow: {
      height: 32,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    tableRowNone: {
      height: 126,
    },
    tblHead: {
      textAlign: "center",
      fontSize: 12,
      fontWeight: 500,
    },
    tblHeadLeft: {
      textAlign: "left",
      fontSize: 12,
      fontWeight: 500,
    },
    tblDataCenter: {
      textAlign: "center",
    },
    tblDataLeft: {
      textAlign: "left",
    },
    customTitle: {
      fontSize: 16,
      color: "#000",
    },
  })
);

function setChipLabel(label, classes) {
  const colorKeyName = label.toLowerCase().replace(/[^A-Z0-9]+/gi, "");
  return <Chip className={classes[colorKeyName]} size="small" label={label} />;
}

const RewardCoinTable = ({ getRewardCoinData, rewardCoinData, dateRangePicTree }) => {
  const classes = useStyles();
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    if (dateRangePicTree[0] !== null && dateRangePicTree[1]!== null
      && initialDataCall) {
      dateRangePicTree();
      setInitialDataCall(false);
    }
  }, [dateRangePicTree]);

  const columns = [
    {
      name: "#",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "プレイヤーID",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span style={{ minWidth: 10 }} className={classes.tblHeadLeft}>
            プレイヤーID
          </span>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataLeft}>{value}</div>;
        },
      },
    },
    {
      name: "プレイヤー名",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span style={{ minWidth: 120 }} className={classes.tblHead}>
            プレイヤー名
          </span>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "チーム",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span className={classes.tblHead}>チーム</span>
        ),
        customBodyRender: (value) => {
          return (
            <div className={classes.tblDataCenter}>
              {setChipLabel(value, classes)}
            </div>
          );
        },
      },
    },
    {
      name: "報酬額",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span className={classes.tblHead}>報酬額</span>
        ),
        customBodyRender: (value) => {
          return (
            <div className={classes.tblDataCenter}>
              {H.FormatNumStrHelper.formatCommaThousand(value)}
            </div>
          );
        },
      },
    },
    {
      name: "発生日時",
      options: {
        filter: false,
        sort: true,
        customHeadLabelRender: (columnMeta) => (
          <span className={classes.tblHead}>
            発生日時
          </span>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
  ];
  const options = {
    filterType: "checkbox",
    filter: false,
    pagination: true,
    search: true,
    print: false,
    download: true,
    viewColumns: false,
    downloadOptions: {
      filename: "報酬コイン獲得データ",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    selectableRows: "none",
    rowsPerPage: 10,
    textLabels: {
      body: {
        noMatch: "データを取得中です。。",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
    rowsPerPageOptions: [10, 20, 50, 100],
  };

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <MUIDataTable
          title={<span className={classes.customTitle}>発生データ</span>}
          data={rewardCoinData}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
};

RewardCoinTable.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  rewardCoinData: state.pictree.rewardCoinData,
  dateRangePicTree: state.page.dateRangePicTree,
});

const mapDispatchToProps = (dispatch) => ({
  getRewardCoinData: (param) => dispatch(getRewardCoinData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(RewardCoinTable));
